// factory-assets — first-party framework content (built-in connectors + skills + bundles)
// Subpath imports: @skaile/workspaces/factory-assets/connectors/<name>
// This root export provides registerAll() for eager loading of all built-in adapters/drivers.

/**
 * Eagerly loads all built-in connector adapters and mount drivers.
 * Intended for use in environments where lazy loading via subpath imports is not desired.
 * Individual adapters and drivers are normally loaded on demand by the connector and mount registries.
 * @docLink packages/factory-assets/api-reference#factory-assets
 */
export async function registerAll(): Promise<void> {
  // Populated in Phase 3 after implementations are moved here
}
